var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_23_817)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(5 1)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8438 19.3281C36.4844 20.9688 37.5 23.1172 37.5 25.4609C37.5 30.2266 33.5156 34.1328 28.7109 34.1328C27.2656 34.1328 25.8594 33.7422 24.5703 33.0781L20 34.25L21.2109 29.7578C20.4688 28.4688 20.0391 26.9844 20.0391 25.4219C20.0391 20.6562 23.9453 16.75 28.7109 16.75C31.0547 16.75 33.2422 17.6875 34.8438 19.3281ZM28.7109 32.6484C32.6953 32.6484 36.0156 29.4062 36.0156 25.4609C36.0156 23.5078 35.1953 21.7109 33.8281 20.3438C32.4609 18.9766 30.6641 18.2344 28.75 18.2344C24.7656 18.2344 21.5234 21.4766 21.5234 25.4219C21.5234 26.7891 21.9141 28.1172 22.6172 29.2891L22.8125 29.5625L22.0703 32.2188L24.8047 31.4766L25.0391 31.6328C26.1719 32.2969 27.4219 32.6484 28.7109 32.6484ZM32.6953 27.2578C32.8906 27.375 33.0469 27.4141 33.0859 27.5312C33.1641 27.6094 33.1641 28.0391 32.9688 28.5469C32.7734 29.0547 31.9141 29.5234 31.5234 29.5625C30.8203 29.6797 30.2734 29.6406 28.9062 29.0156C26.7188 28.0781 25.3125 25.8906 25.1953 25.7734C25.0781 25.6172 24.3359 24.6016 24.3359 23.5078C24.3359 22.4531 24.8828 21.9453 25.0781 21.7109C25.2734 21.4766 25.5078 21.4375 25.6641 21.4375C25.7812 21.4375 25.9375 21.4375 26.0547 21.4375C26.2109 21.4375 26.3672 21.3984 26.5625 21.8281C26.7188 22.2578 27.1875 23.3125 27.2266 23.4297C27.2656 23.5469 27.3047 23.6641 27.2266 23.8203C26.8359 24.6406 26.3672 24.6016 26.6016 24.9922C27.4609 26.4375 28.2812 26.9453 29.5703 27.5703C29.7656 27.6875 29.8828 27.6484 30.0391 27.5312C30.1562 27.375 30.5859 26.8672 30.7031 26.6719C30.8594 26.4375 31.0156 26.4766 31.2109 26.5547C31.4062 26.6328 32.4609 27.1406 32.6953 27.2578Z",
    fill: "#F4731D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_23_817",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_23_817"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_817"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_23_817"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_23_817",
    result: "effect2_dropShadow_23_817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_23_817",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.3ade6c760a152921cf8f3cac0b12d512.svg";
export { ForwardRef as ReactComponent };